/* eslint-disable import/no-anonymous-default-export */
import { EmployeeList } from './EmployeeList';
import { EmployeeEdit } from './EmployeeEdit';
import { EmployeeCreate } from './EmployeeCreate';

export default {
    list: EmployeeList,
    create: EmployeeCreate,
    edit: EmployeeEdit
};